import json from './i18n.fr.json'

/*
Used to migrate nested object into flatten version i,g "foo.bar:2"
function flatObject(obj){
  let newObj = {}
  Object.keys(obj).forEach(key=>{
    if(typeof obj[key]==='object'){
      let flat = flatObject(obj[key])
      Object.keys(flat).forEach(k=>{
        newObj[key+'.'+k] = flat[k]
      })
    }else{
      newObj[key]=obj[key]
    }
  })
  return newObj
}
*/

export default {
  ...json,
}
